import './styles.scss';
import React, { useState, useEffect, useCallback } from 'react';
import { AiOutlineCalendar } from 'react-icons/ai';
import { ReactSVG } from 'react-svg';

import SyncIcon from '../../../assets/images/sync.svg';

import { Modal, Box } from '@material-ui/core';

import { Text, Button } from '../../atoms';
import { getSchedules, getSchedulesTypes } from '../../../services/api';

import 'react-big-calendar/lib/sass/styles.scss';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss';

import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import ModalDetailsEvent from './components/ModalDetailsEvent/ModalDetailsEvent';
import ModalCalendarURL from './components/ModalCalendarURL';

import FilterAgenda from './components/FilterAgenda/FilterAgenda';
import useModalOverflowHidden from '../../../pctHooks/useModalOverflowHidden';

import { formatEvents, sortEvents, TRAINING_OPTIONS, formatDate, formatDateOnly, CustomTooltip } from './helpers';


// ---------------- Component ---------------- //


const CalendarEvent = ({ event }) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    return (
        <div className="calendarEventContent">
            <span className="calendarEventTitle">{event.title}</span>

            {event.meetingRecurrence && (
                <CustomTooltip
                    title="Evento recorrente"
                    placement="top"
                    open={openTooltip}
                    onOpen={() => setOpenTooltip(true)}
                    onClose={() => setOpenTooltip(false)}
                    interactive={false}
                    enterDelay={400}
                    leaveDelay={0}
                >
                    <span
                        className="calendarEventIconWrapper"
                        onMouseLeave={() => setOpenTooltip(false)}
                        onClick={() => setOpenTooltip(false)}
                    >
                        <ReactSVG src={SyncIcon} className="calendarEventIcon" />
                    </span>
                </CustomTooltip>
            )}
        </div>
    );
};

const Agenda = ({ data={}, className = '' }) => {
  const [contentModal, setContentModal] = useState({});
    //estado de data
  const [displayTypes, setDisplayTypes] = useState([]);
  const [selectedIds, setSelectedIs] = useState([]);

  const [fixedList, setFixedList] = useState([]);
  const [loadingCalendar, setLoadingCalendar] = useState(true);
  const [listTypes, setListTypes] = useState([]);
  const [currentEvents, setCurrentEvents] = useState([]);
  
  const [open, setOpen] = useState(false);
  const [openCalendarUrl, setOpenCalendarUrl] = useState(false);

  const localizer = momentLocalizer(moment);
  const [currentDate, setCurrentDate] = useState(moment(new Date()).format('MM-YYYY'));

  useModalOverflowHidden(open || openCalendarUrl);
  // ---------------- Handlers ---------------- //

  const handleTypeFilterChange = useCallback(
    (event) => {
      const value = event.target.value || [];
      setDisplayTypes(value);

        const selectedIds = [...fixedList, ...TRAINING_OPTIONS]
        .filter((item) => item && value.includes(item?.description))
        .map((item) => item.idScheduleType);
        setSelectedIs(selectedIds);
    }, [fixedList]);

  const eventStyleGetter = (event) => ({
    className: event.segmentPosition === 'middle' ? 'eventStyleMiddle' : 'eventStyleInit',
  });

  const infoEvent = (e) => e.title;

  const formatDateEvent = (e) => {
    const format = ['ASYNCHRONOUS', 'BLENDED'].includes(e.modality) ? formatDateOnly : formatDate
      return `${format.format(new Date(e.startDate)).replace(',', '')} - ${format
        .format(new Date(e.endDate))
        .replace(',', '')}`
  };

  const infoEventModal = (e) => ({
    ...e,
    tipo: e.idScheduleType ? listTypes[e.idScheduleType]?.description : null,
    url: e.url || '',
    descricao: e.description && e.description !== 'null' ? e.description : '',
    data:  formatDateEvent(e),
  });

   

  // ---------------- API ---------------- //

    const fetchEvents = useCallback(
        async () => {
    setLoadingCalendar(true);

    const params = {
      period: currentDate,
      scheduleTypes: selectedIds.join(','),
    };

    const result = await getSchedules(params);
    if (result?.data?.success) {


      const schedules = result.data.scheduleResult?.schedules || [];
      
      let events = formatEvents(schedules);
      events = sortEvents(events);
      setCurrentEvents(events);
    }
    setLoadingCalendar(false);
  }, [currentDate, selectedIds]);

  const fetchSchedulesTypes = useCallback(async () => {
    try {
      const result = await getSchedulesTypes();
      const mapped = [];
      (result || []).forEach((v) => {
        if (v?.idScheduleType != null) mapped[v.idScheduleType] = v;
      });
      setFixedList(mapped);
      setListTypes(mapped);
      setDisplayTypes([ ...TRAINING_OPTIONS, ...(result || []),].map((item) => item.description));
    } catch {
      setDisplayTypes([...TRAINING_OPTIONS].map((item) => item.description));
      setListTypes([]);
    }
  }, []);

  const handleNavigate = (date) => {
        const format  = moment(date).format('MM-YYYY');
        if(format !== currentDate){
      setCurrentDate(format);
    }
  };

  // ---------------- Effects ---------------- //

  useEffect(() => {

       if (listTypes.length === 0) 
         fetchSchedulesTypes();

    fetchEvents();
  }, [fetchEvents, fetchSchedulesTypes, listTypes.length]);

  // ---------------- UI ---------------- //

  const defaultMessages = {
    date: 'Data',
    time: 'Hora',
    event: 'Evento',
    allDay: 'Dia Todo',
    week: 'Semana',
    work_week: 'Eventos',
    day: 'Dia',
    month: 'Mês',
    previous: 'Anterior',
    next: 'Próximo',
    yesterday: 'Ontem',
    tomorrow: 'Amanhã',
    today: 'Hoje',
    agenda: 'Agenda',
    noEventsInRange: 'Não há eventos no período.',
    showMore: (total) => `+${total} ${total > 1 ? "eventos" : "evento"}`,
  };
  

  const hasParams = !!data?.parameters;

  return (
      <div className="pctCalendar">
          <div className={`calendarBase ${className || ''}`}>
              <div
                  className={`pctOrganism sectionList ${
                      hasParams && data?.parameters?.description ? 'pctCalendarInText' : ''
                  }`}
              >
                  {data?.parameters?.title && (
                      <Text component="h2" text={data.parameters.title} className="titleSection" />
                  )}
                  {data?.parameters?.description && (
                      <Text component="p" text={data.parameters.description} className="textSectionDescription" />
                  )}
              </div>

              {/* Modal */}
              <Modal open={open} onClose={() => setOpen(false)} className="calendarEventsModal">
                  <ModalDetailsEvent contentModal={contentModal} onClose={() => setOpen(false)} />
              </Modal>

              <Modal open={openCalendarUrl} onClose={() => setOpenCalendarUrl(false)} className="calendarEventsModal">
                  <ModalCalendarURL contentModal={contentModal} onClose={() => setOpenCalendarUrl(false)} />
              </Modal>

              {/* Header */}
              <div className="sectionList titleAg">
                  <AiOutlineCalendar />
                  <Text component="h4" text={data?.title || 'Agenda'} className="titleSection" />
              </div>

              {data?.text ? (
                  <Text component="p" text={data.text} className="sectionList textSectionDescription" />
              ) : null}

              {/* Filters */}
              <div className="sectionList calendarContainer">
                  <FilterAgenda
                      fixedList={fixedList}
                      value={displayTypes}
                      onChange={handleTypeFilterChange}
                      loadingCalendar={loadingCalendar}
                      list={TRAINING_OPTIONS}
                  />
                  <Button
                      text="Sincronizar com meu calendário"
                      className="button06"
                      callEvent={(e) => setOpenCalendarUrl((prev) => !prev)}
                  />
              </div>

              {/* Calendar */}
              <Calendar
                  eventPropGetter={eventStyleGetter}
                  resizable
                  messages={defaultMessages}
                  localizer={localizer}
                  events={currentEvents}
                  showMultiDayTimes
                  startAccessor="start"
                  endAccessor="end"
                  tooltipAccessor={() => null}
                  titleAccessor={infoEvent}
                  components={{
                      event: CalendarEvent,
                  }}
                  onSelectEvent={(e) => {
                      setContentModal(infoEventModal(e));
                      setOpen(true);
                  }}
                  className="sectionList"
                  onNavigate={handleNavigate}
              />
          </div>
      </div>
  );
};

export default Agenda;
